import { render } from "./YouTubeFacade.vue?vue&type=template&id=122d1866"
import script from "./YouTubeFacade.vue?vue&type=script&lang=js"
export * from "./YouTubeFacade.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__